import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Tooltip from 'react-tooltip'
import { Portal } from 'react-portal'
import { string } from 'common/helpers'
import cx from 'classnames'

import s from './ProductNote.scss'


const ProductNote = ({ className, name, img, tooltipPosition, isLink, isMale }) => {
  const slug        = string.kebabCaseify(name)
  const productType = isMale ? 'colognes' : 'perfumes'
  const url         = `https://www.scentbird.com/${slug}-${productType}`

  const wrapperProps = {
    className: cx(s.note, className),
    id: name,
    role: 'note',
    'aria-label': name,
    'data-tip': true,
    'data-for': name,
  }

  const content = (
    <Fragment>
      <img src={img} alt={name} />
      <Portal>
        <Tooltip
          id={`${name}`}
          effect="solid"
          place={tooltipPosition}
        >
          {name}
        </Tooltip>
      </Portal>
    </Fragment>
  )

  if (isLink) {
    return (
      <a href={url} {...wrapperProps}>
        {content}
      </a>
    )
  }

  return (
    <div {...wrapperProps}>
      {content}
    </div>
  )
}

ProductNote.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  img: PropTypes.string,
  tooltipPosition: PropTypes.string,
  isLink: PropTypes.bool,
  isMale: PropTypes.bool,
}

ProductNote.defaultProps = {
  tooltipPosition: 'top',
  isLink: false,
  isMale: false,
}


export default ProductNote
